

/**
 * Creates a color gradient function that maps a numeric value to an RGB color.
 * The gradient transitions from white (for values above or equal to the threshold)
 * to shades of light red for values below the threshold.
 *
 * @param threshold - Optional. If provided, any value greater than or equal to this threshold will return pure white (`rgb(255, 255, 255)`).
 *                    Values below the threshold will be mapped to a gradient from white to light red.
 * @returns A function that takes a number (0-100) and returns an RGB color string.
 */
function createColorGradient(threshold?: number) {
    return function numberToColor(value: number) {
        // Ensure the value is within the valid range
        const boundValue = Math.max(0, Math.min(100, value));

        // If threshold is provided and value is at or above it, return pure white
        if (threshold !== undefined && boundValue >= threshold) {
            return 'rgb(255, 255, 255)';
        }

        // Scale to 0-255, using threshold if provided, otherwise full 0-100 range
        const maxRange = threshold !== undefined ? threshold : 100;
        const x = (boundValue / maxRange) * 255;
        return `rgb(255, ${x}, ${x})`;
    };
}

export default createColorGradient;
